<template>
    <!--begin::App-->
    <div class="d-flex flex-column flex-root app-root" id="kt_app_root">
        <!--begin::Page-->
        <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
            <RouterView v-if="isInitialized"></RouterView>
        </div>
        <!--end::Page-->
    </div>
    <!--end::App-->
    <common-check-session />
</template>

<script lang="ts">
    import {
        defineComponent,
        nextTick,
        onBeforeMount,
        onMounted,
        watch,
    } from "vue";
    import { useRoute } from "vue-router";
    import { reinitializeComponents } from "@/core/plugins/keenthemes";
    import LayoutService from "@/core/services/LayoutService";

    export default defineComponent({
        setup() {
            const route = useRoute();
            const isInitialized = ref(false);
            const systemStore = useSystemStore();

            onBeforeMount(async () => {
                 LayoutService.init();
                await systemStore.init();
                isInitialized.value = true;
            });

            onMounted(() => {
                nextTick(() => {
                    reinitializeComponents();
                });
            });

            watch(
                () => route.path,
                () => {
                    nextTick(() => {
                        reinitializeComponents();
                    });
                }
            );
            return {
                isInitialized
            }
        },
    });
</script>
